<template>
    <b-container class="m-0 p-0 map-main-container">

        <GmapMap :center="{lat: startPosition.lat, lng: startPosition.lng}" 
                :zoom="12" 
                id="map"
                @click="openInfoWindow(null)"
                @center_changed="updateCenter"
                @dragend="dragend">

            <GmapMarker v-for="(item, index) in tradePoints"
                        :key="index"
                        :position="item.Position"
                        :icon="item.Marker"
                        :clickable="true"
                        @click="openInfoWindow(item)">                
            </GmapMarker>

        </GmapMap>

        <div v-if="selectedItem && selectedItem.Opened" class="container-info-window-tt">

            <div class="content-info-window-tt">
                
                <b-row>
                    <b-img v-bind="mainProps"
                        :blank-color="selectedItem.Type.color"
                        class="info-tt-type-color"/>
                </b-row>

                <b-row class="info-window-tt-type">
                    <span class="info-window-tt-type-text">
                        {{ selectedItem.Type.Text }} {{ selectedItem.IsPriceMonitoring ? "| PM" : "" }}
                    </span>
                </b-row>

                <b-row class="m-5px">     
                    <span class="text info-window-tt-name">                
                        {{FirstName}}
                    </span>
                </b-row>

                <b-row class="m-5px">
                    <span class="text info-window-tt-name">                
                        {{LastName}}    
                    </span>           
                </b-row>

                <b-row class="m-5px mb-10">
                    <span class="text info-window-tt-address">                
                    {{selectedItem.Address}}  
                    </span>                
                </b-row>

                <b-row>

                    <b-col>
                        <b-button block variant="outline-primary"
                                id="btn-location" 
                                class="info-window-tt-button location"
                                v-on:click="openNavigator">

                            <font-awesome-icon icon="location-arrow" class="mr-10"/>
                            <span class="text uppercase">
                                В путь
                            </span>
                            
                        </b-button>
                    </b-col>

                    <b-col>
                        <b-button block variant="outline-primary" 
                                id="btn-check"
                                class="info-window-tt-button check" 
                                v-on:click="select()">
                                
                            <font-awesome-icon icon="check" class="mr-10"/>
                            <span class="text uppercase">
                                Выбрать
                            </span>

                        </b-button>
                    </b-col>

                </b-row>

            </div>
        </div>

    </b-container>
</template>

<script>
import '@/assets/styles/client/tradePoints/googleMap.css'

export default {
    props: {
        startPosition: {
            type: Object,
            default: null
        },
        tradePoints: {
            type: [Object, Array],
            default: null
        }
    },
    computed: {
        FirstName: function() {
            if (this.selectedItem.Name) {
                let splitName = this.selectedItem.Name.split('(');
                return splitName[0];
            }
        },
        LastName: function() {
            if (this.selectedItem.Name) {
                let splitName = this.selectedItem.Name.split('(');
                splitName[1] = '(' + splitName[1];
                return splitName[1];
            }
        } 
    },
    data: function() {
        return {
            selectedItem: null,
            mainProps: {blank: true, width: 620, height: 10},
            center: null
        }
    },
    methods:{
        select: function() {
            this.$emit('select', this.selectedItem);
        },
        openInfoWindow: function(item) {
            if(!item && !this.selectedItem)
                return;

            if(!item && this.selectedItem) {
                this.selectedItem.Opened = false;
                return;
            }

            if(this.selectedItem && this.selectedItem.Opened)  
                this.selectedItem.openOrCloseInfoWindow();

            this.selectedItem = item;
            this.selectedItem.openOrCloseInfoWindow();
        },
        updateCenter: function(value) {
            this.center = { lat: value.lat(), lng: value.lng() };
        },
        openNavigator: function() {
            window.open(`https://yandex.ru/maps/?text=${this.selectedItem.Position.lat}%2C%20%20${this.selectedItem.Position.lng}`);
        },
        dragend: function() {
            this.$emit('dragend', this.center);
        }
    }

}
</script>